/**
 * 通过registLoading设置key对应表格的loading状态
 * 所有chart必须写入chartNameList中，在mounted时设置加载，当chart数量和名称不确定时，需要在相应组件watch变化，并初始化
 */
export const loading = {
    data () {
        return {
            loadingText:this.$t('Loading'),
            loading: false,
        }
    },
    methods: {
        registLoading(key,chart){
            this.loading = true
            chart.on('finished', ()=>{this.loading  = false})
        },
    },
    created() {
        this.loading = true
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/loading.js